import React, { useState } from 'react';
import Moment from 'moment';
import './ItemView.css';
import { Row, Col, Button, ListGroup, ListGroupItem, Card, CardBody, CardHeader, Collapse, Table, Modal, ModalHeader, ModalBody, ModalFooter, Badge, FormGroup, Input, Label } from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaMapMarkerAlt, FaDrawPolygon, FaSlash, FaRegCircle, FaRegSquare, FaPencilAlt,FaPlus} from 'react-icons/fa';
import uuid from 'react-uuid';
import MaintenancePlan from '../MaintenancePlan/MaintenancePlan';

const WinterGrazingItemView = ({ handleBlockZoomlevelSave, blockOnly, handleBlockOnlySelect, handleBlockZoomlevel, handleCenterPinClick, mapDetails, item, itemTypesList, toggleItemState, handleItemEditPopup, handleItemDeletePopup, handleOpenActionPopup, handleItemTogole, handleItemHighlight, Section, itemModel, toggleShowCenterPin }) => {

    const [isOpen, setIsOpen] = useState(item.itemId == toggleItemState.itemId ? toggleItemState.isOpen : false);
    const [isIconUp, setIsIconUp] = useState(item.itemId == toggleItemState.itemId ? toggleItemState.isIconUp : false);
    const [isClosedActionShow, setIsClosedActionShow] = useState(false);
    const [maintenancePlanSummaryPopup, setMaintenancePlanSummaryPopup] = useState({ showMaintenancePlanSummaryPopup: false });
    const [imageViewPopup, setImageViewPopup] = useState({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    const [maintenancePlanPopup, setMaintenancePlanPopup] = useState({ showMaintenancePlanPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0, section: '', itemTypes: itemTypesList, maintenancePlanId: 0 , routePath : '' });
    const roleName = localStorage.getItem("roleName");
    const isAddArchiveItem = localStorage.getItem("isAddArchiveItem");
    const isCreateNewAction = localStorage.getItem("isCreateNewAction");
    const hasCentrePin = item.centerCoordinates == null || item.centerCoordinates == '' ? false : true;
    const defaultZoomlevel = blockOnly.itemId == item.itemId && blockOnly.defaultZoomLevel != null ? blockOnly.defaultZoomLevel : item.defaultZoomlevel == null || item.defaultZoomlevel == '' ? mapDetails.zoomLevel : item.defaultZoomlevel;
    const toggle = (itemId) => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
        handleItemTogole(itemId, !isOpen, !isIconUp)
    };

    const handleClosedActionShow = (event) => {
        setIsClosedActionShow(event.target.checked);
    }

    const handleMaintenancePlanSummaryPopup = (event) => {
        event.stopPropagation()
        setMaintenancePlanSummaryPopup({ showMaintenancePlanSummaryPopup: true });
    }

    const handleMaintenancePlanSummaryPopupClose = (event) => {
        setMaintenancePlanSummaryPopup({ showMaintenancePlanSummaryPopup: false });
    }

    const handleImageViewPopup = (event, imageName, imageUrl) => {
        setImageViewPopup({ showImageViewPopup: true, imageName: imageName, imageUrl: imageUrl });
    }

    const handleImageViewPopupClose = (event) => {
        setImageViewPopup({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    }

    /*Item- MaintenancePlan Popup handle*/
    const handleOpenMaintenancePlanPopup = (itemId, itemName, itemTypeId, section, maintenancePlanId, routePath) => {
        setMaintenancePlanPopup({
            ...maintenancePlanPopup, showMaintenancePlanPopup: true,
            itemId: itemId, itemName: itemName, itemTypeId: itemTypeId, actionId: 0,
            section: section, maintenancePlanId: maintenancePlanId, routePath: "/"+ routePath
        });
    }

    const handleMaintenancePlanClose = () => {
        setMaintenancePlanPopup({ ...maintenancePlanPopup, showMaintenancePlanPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0, section: '', maintenancePlanId: 0 });
    }

    

    if (item != undefined) {
        const openActionCount = Section != 'Winter Grazing' ? (item.actions.filter(action => action.isCloseout != true).length) : 0;
        const closedActionCount = Section != 'Winter Grazing' ? (item.actions.filter(action => action.isCloseout == true).length) : 0;
        const hasRisk = Section != 'Winter Grazing' ? (item.isItemHaveAnyRisk == 'Yes' ? true : openActionCount > 0 ? true : false) : false;
        const ImagesCount = item.imageList != null ? item.imageList.length : 0;
        return (
            <div>
                <Row>
                    <Col>
                        <Card>
                            <CardHeader className="item-header" style={{ background:"#4B7E84"}} onClick={(itemId) => toggle(item.itemId)}>
                                <Row>
                                    <Col sm="6">
                                        {Section == 'Community & Cultural Significance' &&
                                            <a onMouseOver={(itemId) => handleItemHighlight(item.itemId)} onMouseOut={(itemId) => handleItemHighlight(0)}>
                                                {item.mapMarkerType == 'marker' ? <FaMapMarkerAlt color="white"></FaMapMarkerAlt> :
                                                    item.mapMarkerType == 'polyline' ? <FaSlash color="white"></FaSlash> :
                                                        item.mapMarkerType == 'polygon' ? <FaDrawPolygon color="white"></FaDrawPolygon> :
                                                            item.mapMarkerType == 'circle' ? <FaRegCircle color="white"></FaRegCircle> :
                                                                item.mapMarkerType == 'rectangle' && <FaRegSquare color="white"></FaRegSquare>}
                                            </a>
                                        }
                                        {Section != 'Community & Cultural Significance' &&
                                            <a onMouseOver={(itemId) => handleItemHighlight(item.itemId)} onMouseOut={(itemId) => handleItemHighlight(0)}>
                                                {item.mapMarkerType == 'marker' ? <FaMapMarkerAlt color={item.colour}></FaMapMarkerAlt> :
                                                    item.mapMarkerType == 'polyline' ? <FaSlash color={item.colour}></FaSlash> :
                                                        item.mapMarkerType == 'polygon' ? <FaDrawPolygon color={item.colour}></FaDrawPolygon> :
                                                            item.mapMarkerType == 'circle' ? <FaRegCircle color={item.colour}></FaRegCircle> :
                                                                item.mapMarkerType == 'rectangle' && <FaRegSquare color={item.colour}></FaRegSquare>}
                                            </a>
                                        }
                                        {' '} <span className="color-dark-teal">{item.name}</span>
                                        {item.isItemHaveAnyRisk == 'Yes' && <span className="risk-badge"><Badge color="danger">
                                            Risk
                                        </Badge></span>}
                                    </Col>
                                    <Col sm="5" className="text-end">
                                        {
                                            !itemModel.isMapOnly && openActionCount > 0 ?
                                                <span className="risk-badge">
                                                    <Badge color="primary">
                                                        {openActionCount}
                                                    </Badge> <span className="card-header-label-xs">Open Actions</span>
                                                </span> :
                                                <></>
                                        }
                                    </Col>
                                    <Col sm="1" className="toggleoutlineItem">
                                        {isIconUp ? <FaChevronUp /> : <FaChevronDown />}

                                    </Col>
                                    </Row>
                            </CardHeader>
                            <Collapse isOpen={isOpen}>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                                <Row>
                                                    <Col sm="5">
                                                        <label className="item-desc para-light-sm ">{item.description}</label>
                                                        <div>Mob name and size: {item.mobNameAndsize}</div>
                                                        <div>Diet following transition: {item.dietFollowingTransition}</div>
                                                    </Col>
                                                    <Col className="" sm="3">
                                                        {(roleName == 'Admin' || isAddArchiveItem == 'true') &&
                                                            <>
                                                                {item.canArchive &&
                                                                    <Button className="btn-items-actions" color="danger" size="sm" onClick={(itemId) => handleItemDeletePopup(item.itemId)} >
                                                                        Archive
                                                                    </Button>
                                                                }
                                                            </>
                                                        }
                                                        <Button className="btn-items-actions" color="warning" size="sm" onClick={(itemId) => handleItemEditPopup(item.itemId)}>
                                                            Edit
                                                        </Button>
                                                    </Col>
                                                    <Col sm="4">
                                                        <ListGroup>
                                                            <ListGroupItem>
                                                                <Row>
                                                                    <Col sm="4">
                                                                        Centre Pin
                                                                    </Col>
                                                                
                                                                
                                                                {hasCentrePin ? <>
                                                                        <Col sm="4">
                                                                            {blockOnly.isViewBlockOnly && blockOnly.itemId == item.itemId &&
                                                                                <FormGroup switch>
                                                                                    <Input
                                                                                        type="switch"
                                                                                        role="switch"
                                                                                        checked={blockOnly.showCenterPin}
                                                                                        onChange={toggleShowCenterPin}
                                                                                    />
                                                                                    <Label check>
                                                                                        {blockOnly.showCenterPin ? "Show" : "Hide"}
                                                                                    </Label>
                                                                                </FormGroup>
                                                                            }
                                                                    </Col>
                                                                    <Col sm="4">
                                                                        <FaMapMarkerAlt className="float-end" color={item.colour}></FaMapMarkerAlt>
                                                                    </Col>
                                                                </>
                                                                    : <><Col sm="4"></Col><Col sm="4"><img
                                                                        className="featureIcon float-end"
                                                                        src="/images/marker.png"
                                                                        onClick={(event) => handleCenterPinClick(event, "marker", item.itemId)}
                                                                    /></Col></>}
                                                                </Row>
                                                            </ListGroupItem>
                                                            <ListGroupItem>
                                                                View this paddock only
                                                                <Input
                                                                    type="checkbox"
                                                                    name="isViewBlockOnly"
                                                                    id="isViewBlockOnly"
                                                                    className="float-end"
                                                                    checked={blockOnly.itemId == item.itemId ? blockOnly.isViewBlockOnly : false}
                                                                    onChange={(event, itemid, zoomlevel) => handleBlockOnlySelect(event, item.itemId, defaultZoomlevel)}
                                                                />
                                                            </ListGroupItem>
                                                            <ListGroupItem>
                                                                Paddock zoom level
                                                                <select className="form-control input-sm map-popup-input-text float-end" name="defaultZoomLevel"
                                                                    disabled={item.itemId == parseInt(blockOnly.itemId) ? false : true}
                                                                    value={defaultZoomlevel} onChange={(event, itemId) => handleBlockZoomlevel(event, item.itemId)}>
                                                                    {blockOnly.zoomLevelList.map(zoomlist =>
                                                                        <option key={uuid()} value={zoomlist.zoomValue}>{zoomlist.zoomText}</option>
                                                                    )}
                                                                </select>

                                                                {blockOnly.isViewBlockOnly && blockOnly.itemId == item.itemId &&

                                                                    <Button
                                                                        className="float-end btn-zoomlevelSave"
                                                                        color="success"
                                                                        size="sm"
                                                                        onClick={(event, itemid, value) => handleBlockZoomlevelSave(event, item.itemId, blockOnly.defaultZoomLevel)}>
                                                                        Save Zoom Level
                                                                    </Button>
                                                                }
                                                            </ListGroupItem>
                                                        </ListGroup>
                                                    </Col>
                                                </Row>
                                                <br />
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Collapse>
                        </Card>
                        <br />
                    </Col>
                </Row>

                <Modal isOpen={imageViewPopup.showImageViewPopup} size="lg" className="imageViewPopup">
                    <ModalHeader toggle={handleImageViewPopupClose} >{imageViewPopup.imageName}</ModalHeader>
                    <ModalBody>
                        <img src={imageViewPopup.imageUrl} className="item-image-popup" alt={imageViewPopup.imageName} ></img>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={handleImageViewPopupClose}>Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }



}
export default WinterGrazingItemView